module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABKCAMAAADUrBehAAAAQlBMVEUAAAAwXOsvXOsyXusvW+s4aPYwXOszXOwwXOswW+owXOwvXOsvXOovXeoxW+wvXOwwXewwXOsvXOswXuswYO8vW+oVapFZAAAAFXRSTlMAmWZMsw3mGHXGi8nDfINsPqWyWiBfKkabAAAA4klEQVRYw+3WWw6DIBRFUYvFVvvweeY/1RKsHiJaUJuUGvaXF1g/aozJbA9YPZK5DsqfHJ8H5Snr9EKlrmoANTeGsdIHOoMkYKXezbFYrg+UYAHwc1+qd4vzYkV/t97TyJNNRR75N7nI5XRJ5sKXC+AmJ/oGCD+eAvTUQOrF5Z3e1Hfpw+kt7ea2p3Zz21P7c3rqFZyeegWnp17B6ak9eVkMZb3OxoXSwV3f+eB5e2VQGWPr5mbWZuQfeZMxqDLWBP/a7OQXI6jMOfgHF3nkv+WV6t9+CyP35mJTPd9cAPy0qxelgW3JI6LtkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fee_standard.png
// module id = p7dE
// module chunks = 8